export default __webpack_public_path__ + "static/media/job_offer9_xl.c0cba6f4.jpg";